/* globals wNumb */

import { onAddressChangedEvent } from '../../Shared/React/js/components/addressSearch/AddressSearch';

(function () {
    'use strict';

    function main() {
        var filtersPage = wo$('#search-filters-partial');
        if (!filtersPage.length) return;

        var filtersData = WhistleOut.readLookupData(filtersPage);
        var criteria = WhistleOut.readLookupData(wo$('[data-search-criteria]'));
        //var address = null;

        var filtersController = {
            init: function () {
                filtersData = WhistleOut.readLookupData(filtersPage);
                criteria = WhistleOut.readLookupData(wo$('[data-search-criteria]'));

                filtersController.initDataSlider(filtersData.dataSlider);
                filtersController.initMinutesSlider(filtersData.minutesSlider);
                filtersController.initCallsSlider(filtersData.callsSlider);
                filtersController.initMessagesSlider(filtersData.messagesSlider);
                filtersController.initPriceSlider(filtersData.priceSlider);
                filtersController.initHotspotRequired(criteria.lines[0].tetherPhone);
                filtersController.registerNotifications();
                filtersController.bindState();

                wo$.each(criteria.lines, function (index) {
                    filtersController.applyPhoneActionsVisibility(index + 1);
                });

                if (filtersData.maximumLines > 1) {
                    filtersPage.find('[data-add-line-span]').show();
                } else {
                    filtersPage.find('[data-add-line-span]').hide();
                }

                filtersPage.find('[data-edit-line]').click(function () {
                    var line = wo$(this).data('line');
                    if (!line) {
                        line = 1;
                    }
                    var modal = wo$('#refine-modal');
                    modal.data('select-line', line);
                    modal.modal('show');
                });

                filtersPage.find('[data-edit-phone]').click(function () {
                    var line = wo$(this).data('line');
                    if (!line) {
                        line = 1;
                    }
                    WhistleOut.MobilePhones.showPhonePicker(
                        false,
                        function (phone) {
                            if (phone.id === -1) {
                                criteria.lines[line - 1].phone = null;
                                criteria.lines[line - 1].hasByodMatch = null;
                                criteria.lines[line - 1].phoneManufacturer = null;
                                criteria.lines[line - 1].simOnly = true;
                                criteria.lines[line - 1].allowPhoneSub = false;
                                if (phone.byod) {
                                    criteria.lines[line - 1].byoPhoneModelId = phone.byod.id;
                                } else {
                                    criteria.lines[line - 1].byoPhoneModelId = null;
                                }
                            } else {
                                criteria.lines[line - 1].phone = phone.shortUrl;
                                criteria.lines[line - 1].phoneManufacturer = phone.manufacturerShortUrl;
                                if (phone.similarPhones === true) {
                                    criteria.lines[line - 1].allowPhoneSub = true;
                                } else {
                                    criteria.lines[line - 1].allowPhoneSub = false;
                                }
                                criteria.lines[line - 1].phonePriceTypes = phone.priceTypes.map(function (pt) {
                                    return { value: pt };
                                });
                                criteria.lines[line - 1].hasByodMatch = phone.hasByodMatch;
                                criteria.refurbishedPhones = phone.refurbishedPhones;
                            }

                            WhistleOut.notifications.fire('FilterChanged', {
                                type: 'Lines',
                                line: line,
                                criteria: criteria
                            });
                        },
                        criteria.lines[line - 1].byoPhoneModelId
                    );
                });

                filtersPage.find('[data-show-byod]').click(function () {
                    var byoModalContainer = wo$('#byo-modal-container');
                    if (byoModalContainer && byoModalContainer.length > 0) {
                        filtersController.showByodPicker();
                    } else {
                        var siteConfiguration = WhistleOut.getSiteConfiguration();
                        wo$.ajax({
                            url: siteConfiguration.byoPhonePickerModalUrl,
                            type: 'GET',
                            success: function (result) {
                                if (result !== '') {
                                    if (!byoModalContainer || byoModalContainer.length < 1) {
                                        wo$('body').append('<div id="byo-modal-container"></div>');
                                        byoModalContainer = wo$('#byo-modal-container');
                                    }
                                    byoModalContainer.html(result);
                                    filtersController.showByodPicker();
                                }
                            }
                        });
                    }
                });

                filtersPage.find('[data-already-byod]').click(function () {
                    var currentPhoneShortUrl = criteria.lines[0].phone;
                    var currentBrandShortUrl = criteria.lines[0].phoneManufacturer;
                    var byoModalContainer = wo$('#byo-modal-container');
                    if (byoModalContainer && byoModalContainer.length > 0) {
                        filtersController.showByodPicker(currentBrandShortUrl, currentPhoneShortUrl);
                    } else {
                        var siteConfiguration = WhistleOut.getSiteConfiguration();
                        wo$.ajax({
                            url: siteConfiguration.byoPhonePickerModalUrl,
                            type: 'GET',
                            success: function (result) {
                                if (result !== '') {
                                    if (!byoModalContainer || byoModalContainer.length < 1) {
                                        wo$('body').append('<div id="byo-modal-container"></div>');
                                        byoModalContainer = wo$('#byo-modal-container');
                                    }
                                    byoModalContainer.html(result);
                                    filtersController.showByodPicker(currentBrandShortUrl, currentPhoneShortUrl);
                                }
                            }
                        });
                    }
                });

                filtersPage.find('[data-remove-phone-button]').click(function () {
                    var line = wo$(this).data('line');
                    if (!line) {
                        line = 1;
                    }
                    criteria.lines[line - 1].phone = null;
                    criteria.lines[line - 1].hasByodMatch = null;
                    criteria.lines[line - 1].phoneManufacturer = null;
                    criteria.lines[line - 1].simOnly = false;
                    criteria.lines[line - 1].allowPhoneSub = false;
                    criteria.lines[line - 1].byoPhoneModelId = null;

                    WhistleOut.notifications.fire('FilterChanged', { type: 'Phone', line: line, criteria: criteria });
                });

                filtersPage.find('[data-remove-line-button]').click(function () {
                    var line = wo$(this).data('remove-line-button');
                    if (!line || line < 1) {
                        line = 1;
                    }

                    if (line > 0) {
                        WhistleOut.startProgress('[data-results-container]', 0.1, 50);
                        criteria.lines.splice(line - 1, 1);
                        WhistleOut.notifications.fire('FilterChanged', { type: 'Lines', criteria: criteria });
                    }
                });

                filtersPage.find('[data-add-line-button]').click(function () {
                    var modal = wo$('#refine-modal');
                    modal.data('select-line', -1);
                    modal.modal('show');
                });

                filtersPage.find('[data-upfront]').click(function () {
                    var maxUpfront = wo$(this).data('upfront');
                    if (WhistleOut.isNumber(maxUpfront)) criteria.maxupfront = maxUpfront;
                    else criteria.maxupfront = null;

                    var text = wo$(this).data('text');
                    wo$('#phone-upfront').find('[data-upfront-text]').text(text);

                    WhistleOut.notifications.fire('FilterChanged', { type: 'Upfront', criteria: criteria });
                });

                filtersPage.find('[data-show-closest-match-button]').click(function () {
                    var line = wo$(this).data('show-closest-match-button');
                    if (!line || line < 1) {
                        line = 1;
                    }
                    criteria.lines[line - 1].allowPhoneSub = true;

                    WhistleOut.notifications.fire('FilterChanged', { type: 'Phone', line: line, criteria: criteria });
                });

                filtersPage.find('[data-dont-show-closest-match-button]').click(function () {
                    var line = wo$(this).data('dont-show-closest-match-button');
                    if (!line || line < 1) {
                        line = 1;
                    }

                    criteria.lines[line - 1].allowPhoneSub = false;

                    WhistleOut.notifications.fire('FilterChanged', { type: 'Phone', line: line, criteria: criteria });
                });
                WhistleOut.applyPopover(filtersPage);
            },

            applyPhoneActionsVisibility: function (line) {
                var lineIndex = 0;
                if (line > 0) {
                    lineIndex = line - 1;
                }

                var filterContainer = filtersPage;
                if (line > 0 && filtersPage.find('[data-line-filter-container=' + line + ']').length > 0) {
                    filterContainer = filtersPage.find('[data-line-filter-container=' + line + ']');
                }

                filterContainer.find('[data-phone-conditional]').hide();
                filterContainer.find('[data-closest-match-shown]').hide();
                filterContainer.find('[data-closest-match-hidden]').hide();
                filterContainer.find('[data-show-when-match-byod]').hide();

                if (criteria.lines[lineIndex].phone) {
                    if (criteria.lines[lineIndex].hasByodMatch) {
                        filterContainer.find('[data-show-when-match-byod]').show();
                    }

                    filterContainer.find('[data-phone-selected]').show();
                    if (criteria.lines[lineIndex].allowPhoneSub) {
                        filterContainer.find('[data-closest-match-shown]').show();
                        filterContainer.find('[data-closest-match-hidden]').hide();
                    } else {
                        filterContainer.find('[data-closest-match-shown]').hide();
                        filterContainer.find('[data-closest-match-hidden]').show();
                    }
                } else {
                    if (criteria.lines[lineIndex].simOnly) {
                        if (criteria.lines[lineIndex].byoPhoneModelId) {
                            filterContainer.find('[data-byod-selected]').show();
                        } else {
                            filterContainer.find('[data-byo-selected]').show();
                        }
                    } else {
                        filterContainer.find('[data-none-selected]').show();
                        filterContainer.find('[data-has-5g]').hide();
                    }
                }
            },
            bindState: function () {
                var $container = wo$('#state-switcher-container');
                if ($container.length !== 0) {
                    var $state = $container.find('#province');
                    if ($state && $state.length > 0) {
                        criteria.state = $state.val();
                    }
                }
            },
            registerNotifications: function () {
                WhistleOut.notifications.add(function (notification, data) {
                    if (notification === 'FilterChanged') {
                        if (data && data.type === 'Phone') {
                            var line = data.line > 0 ? data.line : 1;
                            if (!data.criteria.lines[line - 1].phone) {
                                if (data.criteria.lines[line - 1].simOnly) {
                                    filtersPage.find('.phone-image').attr('src', filtersData.byoPhoneImageUrl);
                                    filtersPage.find('.phone-name').text(filtersData.byoPhoneName);
                                } else {
                                    filtersPage.find('.phone-image').attr('src', filtersData.addPhoneImageUrl);
                                    filtersPage.find('.phone-image').attr('alt', filtersData.selectPhoneModel);
                                    filtersPage.find('.phone-name').text(filtersData.addPhoneName);
                                }
                            }
                            filtersController.applyPhoneActionsVisibility(line);
                        }
                    }

                    WhistleOut.bindPhoneSpecsModal(filtersPage);
                    WhistleOut.bindPhoneGallery(filtersPage);
                });

                removeEventListener(onAddressChangedEvent, filtersController.onAddressChangedHandler);
                addEventListener(onAddressChangedEvent, filtersController.onAddressChangedHandler);
            },

            onAddressChangedHandler: function (e) {
                if (!e.detail) {
                    return;
                }

                criteria.address = e.detail.address == null ? null : e.detail.address.label;
                criteria.postcode =
                    e.detail.address == null || e.detail.address.postcode == null
                        ? null
                        : e.detail.address.postcode.shortName;
                criteria.suppliers = [];
                criteria.networks = [];
                criteria.network = null;

                WhistleOut.notifications.fire('FilterChanged', { type: 'Address', criteria: criteria });
            },

            updateModalData: function () {
                var filtersModal = wo$('#refine-modal').parent();
                if (!filtersModal.length) return;

                var modalData = WhistleOut.readLookupData(filtersModal);
                modalData.lines[0].minutesSlider = filtersData.minutesSlider;
                modalData.lines[0].callsSlider = filtersData.callsSlider;
                modalData.lines[0].dataSlider = filtersData.dataSlider;
                modalData.lines[0].simOnly = filtersData.simOnly;
                modalData.lines[0].messagesSlider = filtersData.messagesSlider;
                modalData.maxPhoneUpfrontSlider = filtersData.init;

                if (!filtersData.selectedPhoneShortUrl || filtersData.selectedPhoneShortUrl == null) {
                    wo$.each(modalData.lines[0].phones, function (index, phone) {
                        phone.isSelected = false;
                    });

                    if (filtersData.simOnly) {
                        var byoPhone = modalData.lines[0].phones.filter(function (phone) {
                            return phone.id === -1;
                        })[0];
                        byoPhone.isSelected = true;
                    } else {
                        var noPhone = modalData.lines[0].phones.filter(function (phone) {
                            return phone.id === -2;
                        })[0];
                        noPhone.isSelected = true;
                    }
                }

                if (filtersData.tab) {
                    wo$.each(modalData.tabs, function (index, contractType) {
                        contractType.isChecked = false;
                    });
                    var selectedContractType = modalData.tabs.filter(function (contractType) {
                        return contractType.key === filtersData.tab;
                    })[0];

                    if (selectedContractType) {
                        selectedContractType.isChecked = true;
                    }
                }
            },

            initDataSlider: function (sliderConfig, rebind) {
                if (sliderConfig) {
                    WhistleOut.createSlider(
                        filtersPage.find('#data-slider'),
                        filtersPage.find('#data-text'),
                        sliderConfig,
                        wNumb({ decimals: 0 }),
                        function () {
                            criteria.lines[0].data = sliderConfig.currentPeg.value;
                            WhistleOut.notifications.fire('FilterChanged', {
                                type: 'Data',
                                line: 1,
                                criteria: criteria
                            });
                        },
                        rebind
                    );

                    WhistleOut.createSlider(
                        filtersPage.find('#data-slider-mobile'),
                        filtersPage.find('#data-text-mobile'),
                        sliderConfig,
                        wNumb({ decimals: 0 }),
                        function () {
                            criteria.lines[0].data = sliderConfig.currentPeg.value;
                            WhistleOut.notifications.fire('FilterChanged', {
                                type: 'Data',
                                line: 1,
                                criteria: criteria
                            });
                        },
                        rebind
                    );
                }
            },

            initMinutesSlider: function (sliderConfig, rebind) {
                if (sliderConfig) {
                    WhistleOut.createSlider(
                        filtersPage.find('#minutes-slider'),
                        filtersPage.find('#minutes-text'),
                        sliderConfig,
                        wNumb({ decimals: 0 }),
                        function () {
                            criteria.lines[0].minutes = sliderConfig.currentPeg.value;
                            WhistleOut.notifications.fire('FilterChanged', {
                                type: 'Minutes',
                                line: 1,
                                criteria: criteria
                            });
                        },
                        rebind
                    );
                }
            },

            initPriceSlider: function (sliderConfig) {
                if (sliderConfig) {
                    WhistleOut.createDoubleSlider(
                        filtersPage.find('#price-slider'),
                        filtersPage.find('#price-text'),
                        sliderConfig,
                        wNumb({ decimals: 0 }),
                        function () {
                            criteria.minSpend = sliderConfig.currentPeg1.value;
                            criteria.maxSpend = sliderConfig.currentPeg2.value;
                            WhistleOut.notifications.fire('FilterChanged', { type: 'Spend', criteria: criteria });
                        },
                        null,
                        true
                    );
                }
            },

            initCallsSlider: function (sliderConfig, rebind) {
                if (sliderConfig) {
                    WhistleOut.createSlider(
                        filtersPage.find('#calls-slider'),
                        filtersPage.find('#calls-text'),
                        sliderConfig,
                        wNumb({ decimals: 0 }),
                        function () {
                            criteria.lines[0].calls = sliderConfig.currentPeg.value;
                            WhistleOut.notifications.fire('FilterChanged', {
                                type: 'Calls',
                                line: 1,
                                criteria: criteria
                            });
                        },
                        rebind
                    );
                }
            },

            initMessagesSlider: function (sliderConfig, rebind) {
                if (sliderConfig) {
                    WhistleOut.createSlider(
                        filtersPage.find('#messages-slider'),
                        filtersPage.find('#messages-text'),
                        sliderConfig,
                        wNumb({ decimals: 0 }),
                        function () {
                            criteria.lines[0].sms = sliderConfig.currentPeg.value;
                            WhistleOut.notifications.fire('FilterChanged', { type: 'Messages', criteria: criteria });
                        },
                        rebind
                    );
                }
            },

            initHotspotRequired: function (inputValue) {
                if (inputValue === undefined || inputValue === null) {
                    return;
                }

                const createHotspotInput = function (id) {
                    const hotspotInput = filtersPage.find(id);
                    hotspotInput.prop('checked', inputValue);
                    hotspotInput.click(function () {
                        criteria.lines[0].tetherPhone = hotspotInput.is(':checked');
                        WhistleOut.notifications.fire('FilterChanged', { type: 'Tethering', criteria: criteria });
                    });
                };
                createHotspotInput('#hotspot-required');
                createHotspotInput('#hotspot-required-mobile');
            },

            showByodPicker: function (brandShortUrl, phoneShortUrl) {
                WhistleOut.byoPhonePickerController.show(
                    function (selectedModel) {
                        criteria.lines[0].phone = null;
                        criteria.lines[0].hasByodMatch = null;
                        criteria.lines[0].phoneManufacturer = null;
                        criteria.lines[0].simOnly = true;
                        criteria.lines[0].allowPhoneSub = false;
                        if (selectedModel) {
                            criteria.lines[0].byoPhoneModelId = selectedModel.selectedModelId;
                        } else {
                            criteria.lines[0].byoPhoneModelId = null;
                        }
                        WhistleOut.notifications.fire('FilterChanged', { type: 'Lines', line: 0, criteria: criteria });
                    },
                    brandShortUrl,
                    phoneShortUrl
                );
            }
        };

        const onFiltersReady = () => {
            filtersPage.find('[data-enable-when-ready]').removeAttr('disabled');
            wo$('#search-modal-button, #search-modal-button2, #embed-modal-button, #embed-modal-button2').removeAttr(
                'disabled'
            );
        };

        filtersController.init();
        WhistleOut.notifications.add(function (notification) {
            if (notification === 'SearchFiltersRendered') {
                filtersController.init();
                onFiltersReady();
            } else if (notification === 'FiltersModalReady') {
                onFiltersReady();
            }
        });
    }

    WhistleOut.initModule(import.meta.url, main);
})();
